<template>
  <div class="content">
    <div class="row">
      <div class="col-md-12">
        <form class="form-horizontal">
          <card class="text-left">
            <template slot="header">
              <h4 class="card-title">알림 전송</h4>
            </template>
            <div>
              <div class="row">
                <label class="col-sm-2 col-form-label">전송 아티스트</label>
                <ArtistSelect
                  class="col-sm-10"
                  @memberChangeEvent="getArtistInfo"
                  :show-title="false"
                  :show-all-units="true"
                  :show-members="false"
                  :is-filter="false"
                />
              </div>
              <div class="row">
                <label class="col-sm-2 col-form-label">타이틀</label>
                <div class="col-sm-6">
                  <base-input placeholder="타이틀" v-model="title" required maxlength="500">
                    <span slot="helpBlock" class="form-text" />
                  </base-input>
                  <div class="char-counter" :class="{ 'near-limit': title && title.length > 450, 'over-limit': title && title.length >= 500 }">
                    {{ (title || "").length.toLocaleString() }} / 500
                  </div>
                </div>
              </div>
              <div class="row">
                <label class="col-sm-2 col-form-label">액션</label>
                <div class="col-sm-4">
                  <el-select class="select-primary" size="large" placeholder="액션 선택" v-model="action">
                    <el-option v-for="opt in actions" :key="opt.value" :value="opt.value" :label="opt.label" />
                  </el-select>
                </div>
              </div>
              <!-- Dynamic parameter inputs by action -->
              <div v-if="action" class="mt-2">
                <div class="row" v-for="p in selectedAction.params" :key="p.key">
                  <label class="col-sm-2 col-form-label">{{ p.key }}</label>
                  <div class="col-sm-6" v-if="p.type === 'string'">
                    <base-input :placeholder="p.placeholder || p.key" v-model="params[p.key]">
                      <span slot="helpBlock" class="form-text" />
                    </base-input>
                  </div>
                  <div class="col-sm-4" v-else-if="p.type === 'number'">
                    <el-input-number :controls="false" :min="1" v-model="params[p.key]" />
                  </div>
                </div>
              </div>
              <div class="row">
                <label class="col-sm-2 col-form-label">전송 타겟</label>
                <div class="col-sm-6">
                  <base-radio name="all" inline v-model="target">전체</base-radio>
                  <base-radio name="userId" inline v-model="target">유저아이디</base-radio>
                  <base-radio name="countryCode" inline v-model="target">국가코드</base-radio>
                  <!--                  <base-radio name="query" inline v-model="target">쿼리</base-radio>-->
                </div>
              </div>
              <div v-if="target === 'userId'">
                <div class="row" style="align-items: flex-start">
                  <label class="col-sm-2 col-form-label">전송유저아이디</label>
                  <div class="col-sm-9">
                    <div class="user-id-meta">
                      <span class="user-count-badge" :class="{ 'user-count-empty': parsedUserIdCount === 0 }">
                        {{ parsedUserIdCount.toLocaleString() }}명
                      </span>
                    </div>
                    <div class="tag-input-box" @click="focusTagInput">
                      <span v-for="(tag, idx) in userIdTags" :key="idx" class="tag-chip">
                        {{ tag }}
                        <button type="button" class="tag-remove" @click.stop="removeTag(idx)">×</button>
                      </span>
                      <input
                        ref="tagInput"
                        class="tag-input-field"
                        v-model="userIdInput"
                        placeholder="ID 입력 후 Enter · 붙여넣기 자동 파싱"
                        @keydown.enter.prevent="onEnter"
                        @keydown="onKeydown"
                        @paste.prevent="onPaste"
                        @compositionstart="isComposing = true"
                        @compositionend="isComposing = false"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="target === 'countryCode'">
                <div class="row">
                  <label class="col-sm-2 col-form-label">국가코드</label>
                  <div class="col-sm-6">
                    <base-input placeholder="국가코드" v-model="countryCode" required>
                      <span slot="helpBlock" class="form-text" />
                    </base-input>
                  </div>
                </div>
              </div>
              <div v-if="target === 'query'">
                <div class="row">
                  <label class="col-sm-2 col-form-label">쿼리</label>
                  <el-popover trigger="hover" placement="top">
                    <div>
                      <div class="popover-body">타겟 유저를 USER_ID로 지정해야합니다 <br />ex) SELECT ID AS USER_ID FROM T_USERS WHERE ~~~</div>
                    </div>
                    <base-button slot="reference"> ? </base-button>
                  </el-popover>
                </div>
                <div class="row">
                  <div class="col-sm-1"></div>
                  <div class="col-sm-11">
                    <base-input placeholder="쿼리">
                      <textarea class="form-control" id="query" rows="30" v-model="query" />
                    </base-input>
                  </div>
                </div>
              </div>
              <hr class="section-divider" />
              <div class="row">
                <label class="col-sm-2 col-form-label">내용</label>
              </div>
              <div class="row">
                <div class="col-sm-1"></div>
                <div class="col-sm-11">
                  <base-input placeholder="내용">
                    <textarea class="form-control" id="content" rows="30" v-model="content" maxlength="6000" />
                  </base-input>
                  <div class="char-counter" :class="{ 'near-limit': content && content.length > 5400, 'over-limit': content && content.length >= 6000 }">
                    {{ (content || "").length.toLocaleString() }} / 6,000
                  </div>
                </div>
              </div>
              <div class="row">
                <label class="col-sm-2 col-form-label">예약전송시간</label>
                <div class="col-sm-4">
                  <el-date-picker type="datetime" placeholder="예약전송시간" v-model="notificationTime">ㅇㅇ</el-date-picker>
                </div>
              </div>
            </div>
          </card>
          <base-button @click="sendNotification(false)" type="success">알림전송</base-button>
          <base-button @click="sendNotification(true)" type="success">예약전송</base-button>
          <base-button @click="goBack" type="default">뒤로</base-button>
        </form>
        <!-- end card -->
      </div>
    </div>
  </div>
</template>
<script>
import { BaseButton, BaseInput, Card } from "@/components/index";
import { Toast } from "@/util/Toast";
import { showAPIErrorToast } from "@/util/ErrorUtils";
import ArtistSelect from "@/pages/Components/ArtistSelect";
import { BlipNamespace } from "@/common/BlipNamespace";
import moment from "moment-timezone";

export default {
  components: {
    Card,
    ArtistSelect,
    BaseButton,
    BaseInput,
  },
  data() {
    return {
      title: null,
      content: null,
      userIdTags: [],
      userIdInput: "",
      isComposing: false,
      unitId: null,
      target: "userId",
      notificationTime: null,
      countryCode: null,
      query: null,
      params: {
        url: null,
        chatId: null,
        messageId: null,
        questId: null,
        unitId: null,
        topicId: null,
        topicType: null,
        collectionId: null,
        fanLogId: null,
        userId: null,
        scheduleId: null,
        noticeId: null,
        message: null,
      },
      repeat: {
        repeatId: null,
        repeatEndDate: null,
        options: [
          { label: "없음", value: null },
          { label: "매일", value: "d" },
        ],
      },
      action: null,
      actions: [
        { label: "openNoticeDetail", value: "openNoticeDetail", params: [{ key: "noticeId", type: "number", required: true }] },
        { label: "openMissionDetail", value: "openMissionDetail", params: [{ key: "questId", type: "number", required: false }] },
        {
          label: "openInnerWebView (풀스크린 웹뷰)",
          value: "openInnerWebView",
          params: [{ key: "url", type: "string", placeholder: "http://example.com", required: true }],
        },
        { label: "openWebView (앱 딥링크)", value: "openWebView", params: [{ key: "url", type: "string", placeholder: "blip://deeplink", required: true }] },

        {
          label: "openChatDetail",
          value: "openChatDetail",
          params: [
            { key: "chatId", type: "number", required: true },
            { key: "messageId", type: "number", required: false },
          ],
        },
        {
          label: "openChatActionDetail",
          value: "openChatActionDetail",
          params: [
            { key: "chatId", type: "number", required: true },
            { key: "messageId", type: "number", required: false },
          ],
        },

        {
          label: "openTopicDetail",
          value: "openTopicDetail",
          params: [
            { key: "unitId", type: "number", required: true },
            { key: "topicId", type: "number", required: false },
            { key: "topicType", type: "string", required: false },
          ],
        },

        {
          label: "openCollectionDetail",
          value: "openCollectionDetail",
          params: [
            { key: "unitId", type: "number", required: true },
            { key: "collectionId", type: "number", required: true },
          ],
        },

        {
          label: "openCommentDetail",
          value: "openCommentDetail",
          params: [
            { key: "unitId", type: "number", required: true },
            { key: "collectionId", type: "number", required: false },
            { key: "topicId", type: "number", required: false },
            { key: "fanLogId", type: "number", required: false },
          ],
        },

        {
          label: "openFanLog",
          value: "openFanLog",
          params: [
            { key: "unitId", type: "number", required: true },
            { key: "userId", type: "number", required: true },
          ],
        },
        {
          label: "openFanLogDetail",
          value: "openFanLogDetail",
          params: [
            { key: "unitId", type: "number", required: true },
            { key: "fanLogId", type: "number", required: true },
          ],
        },

        { label: "openLabMVMilestones", value: "openLabMVMilestones", params: [] },
        { label: "openBadgeDetail", value: "openBadgeDetail", params: [] },

        {
          label: "openScheduleDetail",
          value: "openScheduleDetail",
          params: [
            { key: "unitId", type: "number", required: true },
            { key: "scheduleId", type: "number", required: true },
          ],
        },

        { label: "openUserBadge", value: "openUserBadge", params: [{ key: "unitId", type: "number", required: true }] },

        { label: "openFanLogPost", value: "openFanLogPost", params: [] },

        { label: "showToast", value: "showToast", params: [{ key: "message", type: "string", required: true }] },

        { label: "openAttendance", value: "openAttendance", params: [{ key: "unitId", type: "number", required: true }] },
      ],
    };
  },
  computed: {
    selectedAction() {
      return (this.actions || []).find((a) => a.value === this.action) || { params: [] };
    },
    parsedUserIdCount() {
      return this.userIdTags.length;
    },
  },
  methods: {
    async getArtistInfo(param) {
      this.unitId = param.unitId;
    },
    onEnter() {
      if (this.isComposing) return;
      this.addTagsFromInput();
    },
    focusTagInput() {
      this.$refs.tagInput && this.$refs.tagInput.focus();
    },
    addTagsFromInput() {
      const raw = this.userIdInput.trim();
      if (!raw) return;
      const newTags = raw
        .replace(/\n/gi, ",")
        .split(",")
        .map((id) => id.trim())
        .filter((id) => id.length > 0);
      this.userIdTags = [...this.userIdTags, ...newTags];
      this.userIdInput = "";
    },
    removeTag(idx) {
      this.userIdTags.splice(idx, 1);
    },
    onKeydown(e) {
      if (e.key === "Backspace" && this.userIdInput === "" && this.userIdTags.length > 0) {
        this.userIdTags.pop();
      }
    },
    onPaste(e) {
      const text = e.clipboardData.getData("text");
      const newTags = text
        .replace(/\n/gi, ",")
        .split(",")
        .map((id) => id.trim())
        .filter((id) => id.length > 0);
      this.userIdTags = [...this.userIdTags, ...newTags];
    },
    async sendNotification(isReserved) {
      if (this.title === null) {
        window.Toast.error("제목을 입력해주세요");
        return;
      }
      if (this.title.length > 500) {
        window.Toast.error("타이틀은 500자를 초과할 수 없습니다");
        return;
      }
      if (this.content && this.content.length > 6000) {
        window.Toast.error("본문은 6000자를 초과할 수 없습니다");
        return;
      }
      if (this.target === "userId" && this.userIdTags.length === 0) {
        window.Toast.error("유저아이디를 입력해주세요");
        return;
      }
      if (this.target === "countryCode" && this.countryCode === null) {
        window.Toast.error("국가코드를 입력해주세요");
        return;
      }
      if (this.target === "query" && this.query === null) {
        window.Toast.error("쿼리를 입력해주세요");
        return;
      }
      if (this.target === "query") {
        const query = this.query;
        if (
          query.toUpperCase().includes("INSERT") ||
          query.toUpperCase().includes("UPDATE") ||
          query.toUpperCase().includes("ALTER") ||
          !query.toUpperCase().includes("SELECT")
        ) {
          window.Toast.error("잘못된 쿼리입니다");
          return;
        }
      }
      const param = {
        target: this.target,
        title: this.title,
        message: this.content,
        unitId: this.unitId,
        userIds: null,
        countryCode: null,
        action: null,
        url: null,
        parameter: null,
      };
      if (this.target === "userId") {
        param.userIds = this.userIdTags.join(",");
      } else if (this.target === "countryCode") {
        param.countryCode = this.countryCode;
      } else if (this.target === "query") {
        param.query = this.query;
      }

      // Build action-specific params using schema
      const buildPayload = () => {
        const schema = (this.actions || []).find((a) => a.value === this.action);
        if (!schema) return true; // no action selected or schema not found

        // URL actions put value into param.url; others go to param.parameter (JSON)
        const isUrlAction = this.action === "openWebView" || this.action === "openInnerWebView";

        const out = {};
        for (const p of schema.params || []) {
          const val = this.params[p.key];

          if (p.required && (val === null || val === undefined || val === "")) {
            window.Toast.error(`${p.key} 를 입력해주세요`);
            return null;
          }

          if (p.type === "number") {
            if (val !== null && val !== undefined && val !== "") {
              const n = Number(val);
              if (Number.isNaN(n) || n <= 0) {
                window.Toast.error(`${p.key} 는 0보다 큰 숫자만 입력해주세요`);
                return null;
              }
              out[p.key] = n;
            }
          } else if (p.type === "string") {
            if (typeof val === "string") {
              const t = val.trim();
              if (p.required && !t) {
                window.Toast.error(`${p.key} 를 입력해주세요`);
                return null;
              }
              if (t) out[p.key] = t;
            }
          }
        }

        if (isUrlAction) {
          if (!out.url) {
            window.Toast.error("URL을 입력해주세요");
            return null;
          }
          param.url = out.url;
        } else {
          param.parameter = Object.keys(out).length ? JSON.stringify(out) : null;
        }
        return true;
      };

      param.action = this.action;
      const ok = buildPayload();
      if (!ok) return;

      try {
        if (isReserved) {
          if (!this.notificationTime) {
            Toast.error("예약 알림 시간이 없습니다");
            return;
          }
          if (this.notificationTime < moment()) {
            Toast.error("예약 시간이 현재 시간보다 빠릅니다");
            return;
          }
          await this.$axios.post(`/notification/reserveNotification`, {
            namespace: BlipNamespace.NOTIFICATION,
            metadata: JSON.stringify(param),
            repeat: this.repeat,
            notificationTime: this.notificationTime,
          });
          Toast.success("알림이 예약되었습니다");
        } else {
          await this.$axios.put(`/notification/customNotification`, param);
          Toast.success("알림이 전송되었습니다");
        }
      } catch (e) {
        showAPIErrorToast(e);
      }
    },

    goBack() {
      history.go(-1);
    },
  },
  watch: {
    action() {
      this.params = {
        url: null,
        chatId: null,
        messageId: null,
        questId: null,
        unitId: null,
        topicId: null,
        topicType: null,
        collectionId: null,
        fanLogId: null,
        userId: null,
        scheduleId: null,
        noticeId: null,
        message: null,
      };
    },
  },
};
</script>
<style scoped>
textarea#content {
  max-height: 300px;
}
.bootstrap-switch {
  margin: 6px;
}
.char-counter {
  font-size: 12px;
  color: #aaa;
  margin-top: -8px;
  text-align: right;
  transition: color 0.2s;
}
.char-counter.near-limit {
  color: #e67e22;
}
.char-counter.over-limit {
  color: #e74c3c;
  font-weight: bold;
}
.user-id-meta {
  margin-bottom: 6px;
}
.user-count-badge {
  display: inline-block;
  background: #1d8cf8;
  color: #fff;
  font-size: 12px;
  font-weight: bold;
  padding: 3px 10px;
  border-radius: 12px;
}
.user-count-empty {
  background: #aaa;
}
.section-divider {
  border: none;
  border-top: 1px solid #e8e8e8;
  margin: 20px 0;
}
.tag-input-box {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 6px;
  min-height: 160px;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: #fff;
  cursor: text;
  transition: border-color 0.2s;
}
.tag-input-box:focus-within {
  border-color: #1d8cf8;
  box-shadow: 0 0 0 2px rgba(29, 140, 248, 0.15);
}
.tag-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #e8f4ff;
  color: #1d8cf8;
  border: 1px solid #b3d9ff;
  border-radius: 14px;
  padding: 2px 8px 2px 10px;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
}
.tag-remove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  color: #1d8cf8;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  padding: 0;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  transition: background 0.15s, color 0.15s;
}
.tag-remove:hover {
  background: #1d8cf8;
  color: #fff;
}
.tag-input-field {
  flex: 1;
  min-width: 220px;
  border: none;
  outline: none;
  font-size: 13px;
  background: transparent;
  color: #333;
  padding: 2px 0;
}
.tag-input-field::placeholder {
  color: #bbb;
}
</style>
